// src/pages/StockList.jsx
import React, { useState, useEffect } from 'react';
import { authFetch } from '../utils/api';

export default function StockList() {
  const [stocks,  setStocks]  = useState([]);
  const [query,   setQuery]   = useState('');
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState(null);

  useEffect(() => {
    authFetch('/api/stocks')
      .then(r => r.json())
      .then(d => { setStocks(d.stocks || []); setLoading(false); })
      .catch(e => { setError(e.message); setLoading(false); });
  }, []);

  const filtered = query
    ? stocks.filter(s =>
        s.tradingsymbol.toLowerCase().includes(query.toLowerCase()) ||
        (s.name || '').toLowerCase().includes(query.toLowerCase())
      )
    : stocks;

  return (
    <div style={{ padding: '1rem', maxWidth: 900 }}>
      <h1 style={{ margin: '0 0 0.25rem', fontSize: '1.35rem', fontWeight: 800, color: '#e2e8f0' }}>
        Stock List
      </h1>
      <p style={{ margin: '0 0 1rem', fontSize: '0.78rem', color: '#64748b' }}>
        NSE EQ instruments — {stocks.length} stocks
      </p>

      <input
        type="text"
        placeholder="Search by symbol or company name…"
        value={query}
        onChange={e => setQuery(e.target.value)}
        style={{
          width: '100%', padding: '0.6rem 0.9rem', fontSize: '0.95rem',
          border: '1px solid #cbd5e1', borderRadius: 7, boxSizing: 'border-box',
          marginBottom: '0.75rem',
        }}
      />

      {error && (
        <div style={{ background: '#fee2e2', border: '1px solid #fca5a5', borderRadius: 7, padding: '0.7rem 1rem', color: '#991b1b', marginBottom: '0.75rem' }}>
          {error}
        </div>
      )}

      {loading ? (
        <p style={{ color: '#94a3b8', textAlign: 'center', padding: '2rem' }}>Loading…</p>
      ) : (
        <div style={{ background: '#fff', borderRadius: 10, border: '1px solid #e2e8f0', overflow: 'hidden' }}>
          <div style={{ overflowX: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '0.85rem' }}>
              <thead>
                <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
                  <th style={th}>Symbol</th>
                  <th style={th}>Company Name</th>
                  <th style={{ ...th, textAlign: 'center' }}>Type</th>
                  <th style={{ ...th, textAlign: 'center' }}>Segment</th>
                </tr>
              </thead>
              <tbody>
                {filtered.map(s => (
                  <tr key={s.tradingsymbol} style={{ borderBottom: '1px solid #f1f5f9' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#f8fafc'}
                    onMouseLeave={e => e.currentTarget.style.background = ''}>
                    <td style={{ ...td, fontWeight: 700, color: '#0369a1', fontFamily: 'monospace' }}>
                      {s.tradingsymbol}
                    </td>
                    <td style={td}>{s.name}</td>
                    <td style={{ ...td, textAlign: 'center' }}>
                      <span style={{ background: '#e0f2fe', color: '#0369a1', borderRadius: 4, padding: '1px 6px', fontSize: '0.75rem', fontWeight: 600 }}>
                        {s.instrument_type}
                      </span>
                    </td>
                    <td style={{ ...td, textAlign: 'center', color: '#64748b', fontSize: '0.78rem' }}>{s.segment}</td>
                  </tr>
                ))}
                {filtered.length === 0 && (
                  <tr><td colSpan={4} style={{ textAlign: 'center', padding: '2rem', color: '#94a3b8' }}>
                    No stocks match "{query}"
                  </td></tr>
                )}
              </tbody>
            </table>
          </div>
          <div style={{ padding: '0.5rem 1rem', background: '#f8fafc', borderTop: '1px solid #e2e8f0', fontSize: '0.75rem', color: '#64748b' }}>
            Showing {filtered.length} of {stocks.length} stocks
          </div>
        </div>
      )}
    </div>
  );
}

const th = { padding: '0.55rem 0.75rem', fontSize: '0.75rem', fontWeight: 700, color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.04em', textAlign: 'left' };
const td = { padding: '0.5rem 0.75rem' };
